import { IconDownload, IconShare } from "@tabler/icons-react";

const NewSuccess = () => {
    return (
        <>
            <section className="bg-payment-new bg-white pb-2">
                <div className="top-bar" style={{ paddingBottom: '50px' }}>
                    <div className="d-flex justify-content-center">
                        <img alt="logo" src={require('./../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} className="img-fluid" />
                    </div>
                    <p className="text-white text-center mb-5 fw-bold">
                        سامانه ملی امن ، سریع و آسان
                    </p>
                </div>
                <div className="container top-container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-6 col-12 text-center">
                            <img alt="logo" src={require('./../../assets/media/images/global/reza.webp')} className="profile-img" />
                            <p className="fw-bold mt-3 mb-1">
                                رضا مهوشی
                            </p>
                            <p className="text-muted mb-2">121221212</p>
                            <p className="h5 fw-bold">
                                1,000,000 تومان
                            </p>
                            <span className="badge bg-success-site mt-2 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                پرداخت موفق
                            </span>
                            <div className="px-4">
                                <ul className="list-group list-group-flush mt-4 px-0">
                                    <li className="list-group-item px-0">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                                مبلغ کامزد (ریال)
                                            </span>
                                            <span className="fw-bold">7,200</span>
                                        </div>
                                        <hr />
                                    </li>
                                    <li className="list-group-item border px-0">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                                شماره پیگیری
                                            </span>
                                            <span className="fw-bold">1231231</span>
                                        </div>
                                        <hr />
                                    </li>
                                    <li className="list-group-item px-0">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">
                                                شماره مرجع
                                            </span>
                                            <span className="fw-bold">1231231</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="d-flex justify-content-center px-3 mt-4">
                                <button className="btn btn-site-green w-100 ms-2 text-white">
                                    <IconShare />
                                    <p className="mb-0 mt-1">
                                        اشتراک گذاری
                                    </p>
                                </button>
                                <button className="btn btn-site-green w-100 ms-2 text-white">
                                    <IconDownload />
                                    <p className="mb-0 mt-1">
                                        ذخیره در گالری
                                    </p>
                                </button>
                            </div>
                            <p className="text-center fw-bold mb-0 mt-2" style={{ color: '#FFB72B' }}>
                                توهم ایران تراکنشی شو
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default NewSuccess;